import { z } from 'zod';

import {
  ShipmentSourceEvidenceSchema,
  validateShipmentSourceEvidencePair,
} from '../shipments/shipments-shared.schema.js';
import { CoverShipmentHeaderSchema } from './cover-shipments-shared.schema.js';
import type {
  UpdateCoverShipmentHoldingUnitEvidenceRequest,
  UpdateCoverShipmentHoldingUnitEvidenceResponse,
} from './update-cover-shipment-holding-unit-evidence.dto.js';

export const UpdateCoverShipmentHoldingUnitEvidenceRequestSchema: z.ZodType<UpdateCoverShipmentHoldingUnitEvidenceRequest> =
  z
    .object({
      companyId: z.uuid(),
      coverShipmentId: z.uuid(),
      stationId: z.uuid(),
      ...ShipmentSourceEvidenceSchema.shape,
    })
    .strict()
    .superRefine(validateShipmentSourceEvidencePair);

export const UpdateCoverShipmentHoldingUnitEvidenceResponseSchema: z.ZodType<UpdateCoverShipmentHoldingUnitEvidenceResponse> =
  z
    .object({
      coverShipment: CoverShipmentHeaderSchema,
    })
    .strict();
